import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/checkInSaga";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import YearOverYear from "./smartComponents/YearOverYear";
import DatePicker from "./smartComponents/DatePicker";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import { DataPoints } from "./smartComponents/DataPoints";
import { addSticky } from "../../../utils/addSticky";
import HeatMapChart from "./smartComponents/HeatMapChart";
import GroupByFilter from "./smartComponents/groupByFilter";
import GroupByTimeOfDayChart from "./smartComponents/groupByTimeOfDayChart";
import MembershipTypeFilter from "./smartComponents/MembershipTypeFilter";
import ShowPercentageToggle from "./smartComponents/ShowPercentageToggle";
import { UpdateBtns } from "./smartComponents/UpdateBtns";

export const checkInsModule = ({ numberOfMonths, ...restProps }) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    updatesLoading,
    series,
    groupByTimeOfDay,
    selectedFilters: { membership_types }
  } = useSelector((state) => state.checkIns);

  const getData = () => {
    dispatch(
      actionCreators.fetchCurrentUser({
        currentUser: restProps,
        numberOfMonths: numberOfMonths
      })
    );
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!isLoading) {
      addSticky();
    }
  }, [isLoading]);

  return (
    <div className="check-in-module">
      <SectionToggle
        maxHeight="auto"
        autoHeight
        title="Check-Ins"
        customClass="class-check-in-heatmap withSticky"
        hideToggle
        isLoading={isLoading}
        content={
          <div>
            <div className="edit-selections-bar" id="sticky-select-bar">
              <div className="selection-bar-filters">
                <MembershipTypeFilter />
                <div className="select-box" style={{ width: "360px" }}>
                  <p className="offers-title">Date Range</p>
                  <CustomDateRanges />
                </div>
                <div className="date-select-box select-box multi">
                  <p className="offers-title">Date</p>
                  <DatePicker />
                </div>
              </div>

              <UpdateBtns reset={getData} />
            </div>
            {updatesLoading ? (
              <LoadingAnimation text="Updating heatmap..." />
            ) : (
              <div className="content-wrapper">
                <DataPoints />
                {series.length !== 0 && membership_types.length ? <YearOverYear /> : null}
              </div>
            )}
            {series?.length !== 0 && membership_types?.length ? (
              <div style={{ paddingTop: "50px" }}>
                <div className="heatmap-heading">
                  <h2>Check-In Heatmap</h2>
                  <div className="heatmap-filters">
                    <GroupByFilter />
                    <ShowPercentageToggle />
                  </div>
                </div>
                {updatesLoading ? (
                  <LoadingAnimation />
                ) : groupByTimeOfDay ? (
                  <GroupByTimeOfDayChart />
                ) : (
                  <HeatMapChart />
                )}
              </div>
            ) : (
              <p className="error">No data found, please update filters and try again.</p>
            )}
          </div>
        }
      />
    </div>
  );
};

export default checkInsModule;
